import { configureStore } from '@reduxjs/toolkit'
import invoiceReducer from "./slices/invoiceSlice";
import appReducer from "./slices/app"

export default configureStore({
    reducer: {
        invoice: invoiceReducer,
        app: appReducer
    }
})
